import React from 'react';

const ICON_GRADIENTS = {
  teal: 'from-teal-500 to-emerald-600',
  sky: 'from-sky-500 to-blue-600',
  purple: 'from-purple-500 to-indigo-600',
  amber: 'from-amber-500 to-orange-600',
  slate: 'from-slate-500 to-slate-700',
};

/**
 * بخش نام‌دار صفحه جزئیات: آیکون، عنوان و یک خط توضیح تا کاربر در نگاه اول بداند هر بخش چه چیزی نشان می‌دهد.
 *
 * @param {boolean} plain بدون کادر (برای محتوایی که کارت‌های خودش را دارد)
 */
const DetailSection = ({ icon, title, description, color = 'teal', extra, plain = false, children, id }) => (
  <section id={id} className="custom-font min-w-0 scroll-mt-24">
    <header className="flex items-center justify-between gap-2 flex-wrap mb-2">
      <div className="flex items-center gap-2 min-w-0">
        <span className={`w-7 h-7 rounded-lg bg-gradient-to-br ${ICON_GRADIENTS[color]} text-white text-sm flex items-center justify-center shadow-sm shrink-0`}>
          {icon}
        </span>
        <h2 className="text-sm font-bold text-gray-800 dark:text-gray-100 m-0 leading-6 shrink-0">{title}</h2>
        {description && (
          <span className="text-[11px] text-gray-400 dark:text-gray-500 truncate hidden sm:inline">— {description}</span>
        )}
      </div>
      {extra}
    </header>
    {plain ? children : (
      <div className="rounded-xl border border-gray-100 dark:border-gray-700/60 bg-white dark:bg-gray-800/60 shadow-sm p-3 md:p-4">
        {children}
      </div>
    )}
  </section>
);

export default DetailSection;
